import axios from 'axios';
import { redirectPermission, generateUrl, getAccessToken, getTenantId } from '../helper';

const users = axios.create({
    baseURL: generateUrl('user_backend'),
});

users.interceptors.request.use(
    function (config) {
        config.headers.Authorization = `Bearer ${getAccessToken}`;
        const tenantId = getTenantId();
        if (tenantId && tenantId !== 'undefined' && tenantId !== 'null') {
            config.headers['x-tenant-id'] = tenantId;
        } else {
            delete config.headers['x-tenant-id']; // ensure it’s not passed at all
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

users.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        if (error.response.status === 401) {
            redirectPermission();
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);

export default users;
